const style: React.CSSProperties = {
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0,
};

export function VisuallyHiddenH1({ title }: { title: string }) {
  if (!title) {
    return null;
  }
  return <h1 style={style}>{title}</h1>;
}
